import React, {
  ReactElement,
  useEffect,
  useState,
  useRef,
  useMemo,
} from 'react';
import { SchemaWithClient } from '../../types/SchemaWithClient';
import { Entity } from '../../types/entities/Entity';
import api from '../../services/api';
import { SlidingPaneAddNew } from '../Page/SlidingPaneAddNew';
import {useStateContext} from "../../hooks/useStateContext";
import {LoadingPage} from "../../pages/LoadingPage/LoadingPage";
import {NotFound} from "../../pages/NotFound/NotFound";
import Box from "@mui/material/Box";
import {Panel, PanelGroup, PanelResizeHandle} from "react-resizable-panels";
import {Page} from "../Page/Page";
import styles from "../Document/styles.module.css";
import {serviceReservationAddNew} from "../../schema/serviceReservationAddNew";
import {SlidingPane} from "../Page/SlidingPane";
import {activityReservation} from "../../schema/activityReservation";
import Table from '../Table/NewTable';
import {Dialog} from "@mui/material";
import { TransitionProps } from '@mui/material/transitions';
import Slide from "@mui/material/Slide";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type Props<T extends Entity> = {
  schema: SchemaWithClient<T>;
};

export const ActivityReservation = ({
  schema,
  values,
}: {
  schema: any;
  values: any;
}): ReactElement => {

  const [loading, setLoading] = useState<any>(false);
  const [fullWidth, setFullWidth] = useState(false);
  const panelRef: any = useRef(null);
  const [width, setWidth] = useState(40);
  const [serviceReservationSchema, setServiceReservationSchema] = useState(activityReservation());
  const [columnMask, setColumnMask] = useState(undefined);
  const searchParams = useMemo(() => {
    const searchParams = new URLSearchParams();
    return searchParams;
  }, []);
  const [openedPanel, setOpenedPanel] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState<any>();
  const {user} = useStateContext();
  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({
    schema: serviceReservationSchema,
    row: {},
  });
  const [openedSlidingPaneAddNew, setOpenedSlidingPaneAddNew] = useState<any>({
    schema: serviceReservationSchema,
    row: {},
  });
  const [view, setView] = useState<any>(undefined);

  const handlePanelWidth = (fullWidth: boolean) => {
    setFullWidth(fullWidth);
    if (panelRef.current) {
      panelRef.current.resize(fullWidth ? 100 : width);
    }
  };

  const openSlidingPaneHandle = (
    row: any,
    schema: any,
    newEntity?: boolean,
    openInFull?: boolean,
    tab?: string
  ) => {

    if (newEntity) {
      setOpenedSlidingPaneAddNew({
        schema: schema,
        row: row === undefined ? {} : row,
        tab: tab,
      });
    } else {
      setOpenedSlidingPane({
        schema: serviceReservationSchema,
        row: row === undefined ? {} : row,
      });
    }

    if (row) {
      if (!openedPanel) {
        setOpenedPanel(true);
      }
    } else {
      setOpenedPanel(false);
    }

    handlePanelWidth(!!openInFull);
  };


  const mainFunctionRef: any = React.useRef(null);
  const handleRefreshMainTableData = () => {
    mainFunctionRef.current();
  };
  const handleClose = () => {
    setOpenedSlidingPane({
      schema: serviceReservationSchema,
      row: {},
    });
  };

  useEffect(() => {
    setLoading({...loading, ['table']: true});
    api.get(`/users/${user.id}/views/activity_reservations`).then((res: any) => {
      setLoading({...loading, ['table']: false});
      setView(res);

      const columnMaskObj = res.columns.reduce((acc: any, column: any) => {
        return {
          ...acc,
          [column.name]: true,
        };
      }, {});
      columnMaskObj[`__tree_data_group__`] = false;
      setColumnMask(columnMaskObj);
    });
  }, []);

/*  useEffect(() => {

    setTimeout(()=>{
      if (panelRef.current) {
        panelRef.current.resize(fullWidth ? 100 : width);
      }
    },500);

  }, [openedSlidingPane, panelRef, fullWidth]);*/

  if (loading.table) {
    return <LoadingPage />;
  }

  if (!view) {
    return <NotFound />;
  }

  return (
    <>
      <Box
        sx={{
          p: '0px',
          background: '#fff',
          height: '600px',
          width: '100%',
        }}
      >
        <PanelGroup direction="horizontal">
          <Panel>
            <Page title={'Activity Reservations'}>
              {() => {
                return (
                  <PanelGroup
                    key={1}
                    autoSaveId="example"
                    direction="vertical"
                  >
                    <Panel
                      className={`${styles.Panel}`}
                      collapsible={true}
                      defaultSize={100}
                      order={1}
                    >
                      <Table
                        setFunctionRef={(ref: any) =>
                          (mainFunctionRef.current = ref)
                        }
                        searchParams={searchParams}
                        columnMask={columnMask}
                        schema={serviceReservationSchema}
                        onRowSelected={(row: any) => {

                        }}
                        isView={true}
                        viewId={view.id}
                        pins={view?.pins}
                        selectedRowId={selectedRowId}
                        selectedGroupId={values}
                        setCurrentEditedRow={(
                          row: any,
                          openInFull?: boolean
                        ) => {
                          openSlidingPaneHandle(
                            row,
                            serviceReservationSchema,
                            false,
                            openInFull
                          );
                        }}
                        setCurrentAddNewRow={(row: any) => {
                          openSlidingPaneHandle(
                            row,
                            serviceReservationAddNew,
                            true
                          );
                        }}
                        reservationDialog={{
                          name: values?.activity?.name,
                          activity: {
                            id: values?.activity?.id,
                            name: values?.activity?.name,
                          },
                          group: {
                            id: schema?.name === 'Group' ? values?.id : values?.group?.id,
                            name: schema?.name === 'Group' ? values?.name : values?.group?.name,
                          },
                        }}
                        isInFullPanel
                        openedPanel={openedPanel}
                      />
                    </Panel>

                  </PanelGroup>
                );
              }}
            </Page>
          </Panel>
          {(!fullWidth && openedSlidingPane?.row?.id) && (
            <>
              <PanelResizeHandle
                className={`${styles.ResizeHandleOuter} bg-[#ddd]`}
              >
                <div className={styles.ResizeHandleInner}>
                  <svg className={styles.Icon} viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z"
                    />
                  </svg>
                </div>
              </PanelResizeHandle>
              <Panel
                className={`${styles.Panel}`}
                collapsible={false}
                minSize={20}
                defaultSize={40}
                ref={panelRef}
              >
                <SlidingPane
                  setFullWidthProp={(value) => {
                    console.log('setFullWidthProp');
                    handlePanelWidth(value);
                  }}
                  fullWidth={fullWidth}
                  schema={openedSlidingPane?.schema}
                  id={
                    openedSlidingPane?.hasOwnPane
                      ? undefined
                      : openedSlidingPane?.row?.id
                  }
                  onSubmit={() => {
                    handleRefreshMainTableData();
                  }}
                  propertiesFromTable={
                    openedSlidingPane?.row ? openedSlidingPane?.row : {}
                  }
                  onClose={(value) => {
                    if (
                      openedSlidingPane?.schema?.viewTable ===
                      'activity_reservation'
                    ) {
                      serviceReservationSchema.client
                        .deleteLock(value?.id, {
                          schema: JSON.stringify(
                            openedSlidingPane?.schema.client
                          ),
                        })
                        .then((result: any) => {
                        });
                    } else {
                    }
                    setOpenedSlidingPane({
                      schema: serviceReservationSchema,
                      row: {},
                    });
                  }}
                  isInFullPanel={true}
                  addNewRow={(schema: any, tab: any) => {
                    console.log('openSlidingPaneHandle 5 ---');
                    openSlidingPaneHandle(
                      {
                        id: 'new',
                        group: openedSlidingPane?.row,
                      },
                      schema,
                      true,
                      false,
                      tab
                    );
                  }}
                />
              </Panel>
            </>
          )}
        </PanelGroup>
      </Box>

      {(fullWidth && openedSlidingPane?.row?.id) && (
        <>
          <Dialog
            fullScreen
            open={true}
            onClose={handleClose}
            TransitionComponent={Transition}
          >
            <SlidingPane
              setFullWidthProp={(value) => {
                handlePanelWidth(value);
              }}
              fullWidth={fullWidth}
              schema={openedSlidingPane?.schema}
              id={
                openedSlidingPane?.hasOwnPane
                  ? undefined
                  : openedSlidingPane?.row?.id
              }
              onSubmit={() => {
                handleRefreshMainTableData();
              }}
              propertiesFromTable={
                openedSlidingPane?.row ? openedSlidingPane?.row : {}
              }
              onClose={(value) => {
                if (
                  openedSlidingPane?.schema?.viewTable ===
                  'activity_reservation'
                ) {
                  serviceReservationSchema.client
                    .deleteLock(value?.id, {
                      schema: JSON.stringify(
                        openedSlidingPane?.schema.client
                      ),
                    })
                    .then((result: any) => {
                    });
                } else {
                }
                setOpenedSlidingPane({
                  schema: serviceReservationSchema,
                  row: {},
                });
              }}
              isInFullPanel={true}
              addNewRow={(schema: any, tab: any) => {
                console.log('openSlidingPaneHandle 5 ---');
                openSlidingPaneHandle(
                  {
                    id: 'new',
                    group: openedSlidingPane?.row,
                  },
                  schema,
                  true,
                  false,
                  tab
                );
              }}
            />
          </Dialog>

        </>
      )}

      {openedSlidingPaneAddNew?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={openedSlidingPaneAddNew?.schema}
            id={openedSlidingPaneAddNew?.row?.id}
            onSubmit={() => {
              setOpenedSlidingPaneAddNew({
                schema: serviceReservationSchema,
                row: {},
              });
              handleRefreshMainTableData();
            }}
            propertiesFromTable={{
          /*    group: row?.group,
              activity: row?.activity,
              activity_reservation: row?.activity_reservation,*/
            }}
            onClose={(value) => {
              setOpenedSlidingPaneAddNew({
                schema: serviceReservationSchema,
                row: {},
              });
            }}
          />
        </>
      )}
    </>
  );
};
